import { toast } from "./toast";

export default function ShareModal() {
  const shareBtn = document.querySelector(".js-share-btn");
  const shareModal = document.querySelector(".js-share-modal");
  const closeBtns = document.querySelectorAll(".js-share-modal-close-btn");
  const shareOverlay = document.querySelector(".js-share-overlay");
  const copyLinkBtn = document.querySelector(".js-share-copy-link");

  if (!shareBtn || !shareModal) return;

  const sendByEmailBtn = shareModal.querySelector(".js-send-by-email");
  const shareForm = shareModal.querySelector(".js-share-form");

  shareModal.style.display = "block";
  shareBtn.addEventListener("click", () => {
    shareModal.classList.add("is-open");
    trapFocus(shareModal);
    setTimeout(() => shareModal.querySelector("a")?.focus(), 10);
    document.body.classList.add("stop-scrolling");
  });
  closeBtns?.forEach((closeBtn) =>
    closeBtn.addEventListener("click", closeModal)
  );
  shareOverlay?.addEventListener("click", closeModal);

  sendByEmailBtn?.addEventListener("click", () =>
    shareModal.classList.add("is-email")
  );

  shareForm?.addEventListener("submit", onShareFormSubmit);

  copyLinkBtn?.addEventListener("click", onCopyLinkClick);

  function onCopyLinkClick() {
    const shareUrl = copyLinkBtn.dataset.shareUrl;
    navigator.clipboard.writeText(shareUrl);

    toast.success("Link copied successfully!");
  }

  async function onShareFormSubmit(e) {
    e.preventDefault();

    if (!validateShareForm(shareForm)) {
      return;
    }

    const action = shareForm.action;
    const method = shareForm.getAttribute("method") || "post";

    try {
      setLoadingState(true);
      const recaptchaSiteKey = shareForm.dataset.recaptchaSiteKey;
      if (recaptchaSiteKey) {
        const token = await grecaptcha.execute(recaptchaSiteKey, {
          action: "submit",
        });
        const tokenInput = shareForm.querySelector("#FormToken");
        tokenInput.value = token;
      }

      const formData = new FormData(shareForm);

      const response = await fetch(action, {
        method: method.toUpperCase(),
        body: formData,
      });

      setLoadingState(false);

      if (!response.ok) {
        throw new Error(response.body);
      }

      shareModal.classList.add("is-form-success");
    } catch (error) {
      console.error(error);
    }
  }

  function setLoadingState(isLoading) {
    isLoading
      ? shareModal.classList.add("is-loading")
      : shareModal.classList.remove("is-loading");
  }

  function closeModal() {
    shareModal.classList.remove("is-open");
    document.body.classList.remove("stop-scrolling");
    setTimeout(resetFormSteps, 1000);
  }

  function trapFocus(modal) {
    const focusableElements = modal.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusableElements.length) return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Tab") {
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    });
  }

  function resetFormSteps() {
    shareModal.classList.remove("is-email");
    shareModal.classList.remove("is-form-success");
    setLoadingState(false);
  }

  function validateShareForm(form) {
    const emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) {
      return false;
    }

    const emailValue = emailInput.value.trim();

    if (!emailValue) {
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailValue)) {
      return false;
    }

    return true;
  }
}
